import React, { useState } from "react";
import { FaTable, FaList, FaRegCalendarAlt } from "react-icons/fa";
import Agenda from "./agenda";



export const ViewSelect = ({ selected, setSelected ,viewOptions, setIsAgendaOpen, isOpen, setIsOpen,setSelectedEvent}) => {
    

    return (
        <div className="relative w-48 h-[42px]">
            <button
                className=" text-sm rounded-lg block w-full p-2 flex items-center justify-between border border-[#1A1A1B]"
                onClick={() =>{ setSelectedEvent(false);setIsOpen(!isOpen)}}
            >
                <span className="flex items-center gap-2 text-[16px] font-semibold">
                    {viewOptions.find((option) => option.value === selected)?.selectedIcon}
                    {selected}
                </span>
                <span class="relative right-[-5px] top-[12px] transform -translate-y-1/2 pointer-events-none px-1"><svg width="18" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" stroke="#245CEA" strokeWidth="2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round"></path></svg></span>
            </button>

            {isOpen && (
                <ul className="absolute w-full bg-white border border-gray-200 shadow-md rounded-lg mt-1 z-10">
                    {viewOptions.map((option) => (
                        <li
                            key={option.value}
                            className="flex items-center gap-2 px-4 py-2 cursor-pointer hover:bg-gray-100"
                            
                            onClick={() => {
                                setIsOpen(false);
                                if (option.value==='Agenda') {
                                    setIsAgendaOpen(true)

                                }
                                else {
                                    setSelected(option.value);
                                    
                                }
                                
                            }}
                        >
                            {option.icon} {option.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};


